// src/pages/OAuthReturnPage.js
//
// Landing page for OAuth returns (Gmail connect). The gmail-oauth-callback
// edge function 302s here with the result in query params. It lives on the
// APP origin because Supabase's function gateway refuses to serve HTML
// (rewrites to text/plain + CSP sandbox on *.supabase.co).
//
// Popup flow: broadcast the result to every open app window — a
// BroadcastChannel is same-origin so it works even when Google's COOP
// headers sever the popup's opener reference — then close the popup.
// Full-page flow (or a popup that the browser refuses to close): continue
// into the app with the params intact so /orders-tracking can react.
import React, { useEffect } from 'react';

const OAuthReturnPage = () => {
  useEffect(() => {
    const params = window.location.search.replace(/^\?/, '');
    try {
      const bc = new BroadcastChannel('nexus-oauth');
      bc.postMessage({ source: 'nexus-gmail-oauth', params });
      bc.close();
    } catch { /* ancient browser — the redirect fallback below still works */ }
    try { window.close(); } catch { /* ignore */ }
    const t = setTimeout(() => {
      window.location.replace(`/orders-tracking?${params}`);
    }, 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#09090b',
        color: '#a1a1aa',
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
      }}
    >
      <p>Finishing up…</p>
    </div>
  );
};

export default OAuthReturnPage;
